import { useCallback } from 'react';

import type { lotusHealthSchemas } from '@lotushealth/lotushealth_js_sdk';

import { useAgentTweakableCopilotIntegration } from '../agent-tweakable';
import { useCopilotToolRegistry } from '../tooling/useCopilotToolRegistry';
import { composePromptFragment } from './composePromptFragment';

export type ChatInjectionsBundle = {
  injections: lotusHealthSchemas.HostageInjectionsT;
  debug: {
    injectedToolCount: number;
    injectedToolNames: string[];
    promptLineCount: number;
    promptKeySample: string[];
  };
};

export function useChatInjectionBuilder() {
  const { registry } = useCopilotToolRegistry();
  const { getFrontendContextPromptFragmentInfo } = useAgentTweakableCopilotIntegration();

  const buildChatInjections = useCallback((): ChatInjectionsBundle => {
    const frontendPrompt = getFrontendContextPromptFragmentInfo();
    const composedPromptFragment = composePromptFragment(frontendPrompt.text);
    const injectedToolDefinitions = registry.getToolDefinitions();
    const injectedToolNames = injectedToolDefinitions.map((t) => t.name);

    return {
      injections: {
        prompt_fragment: composedPromptFragment,
        tool_definitions: injectedToolDefinitions,
      },
      debug: {
        injectedToolCount: injectedToolDefinitions.length,
        injectedToolNames,
        promptLineCount: frontendPrompt.lineCount,
        promptKeySample: frontendPrompt.keySample,
      },
    };
  }, [getFrontendContextPromptFragmentInfo, registry]);

  return { buildChatInjections, registry };
}
